import React, { useEffect, useState } from 'react'
import './side-menu.styles.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faBell, faTrophy, faSuitcase, faGem, faMagnifyingGlass, faGear, faShoppingCart, faUserSecret, faFlag, faMap, faUsers, faListDots, faRectangleList, faListCheck, faEarthAmericas, faDiceSix, faDice, faGlobeAmericas, faToolbox } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'

export function switchPlayerMenu(id) {
    // const btns = document.getElementsByClassName('menu-btn')
    // for (let btn of btns) {
    //     btn.classList.remove('active');
    // }
    // document.getElementById(id).classList.add('active');
}

const PlayerSideMenu = ({ 
    gameData, 
    playerData, 
    gameElements,
    teamMembers
}) => {
    
    const location = useLocation();
    const [ path, setPath ] = useState('');
    const [ rewardCount, setRewardCount ] = useState(0);
    const [ showTeams, setShowTeams ] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!location) return;
        setPath(location.pathname);
    }, [location])

    useEffect(() => {
        if (!playerData) return;
        if (playerData.newStuff && playerData.newStuff.length > 0) {
            let count = 0;
            for (let newStuffInfo of playerData.newStuff) {
                if (
                    newStuffInfo.display === 'reward' ||
                    newStuffInfo.display === 'prizepack' ||
                    newStuffInfo.display === 'achievement' ||
                    newStuffInfo.display === 'purchase'
                ) {
                    count++;
                }
            }
            setRewardCount(count);
        } else {
            setRewardCount(0);
        }
    }, [playerData])

    useEffect(() => {
        if (!teamMembers) return;
        let showTeam = false;
        for (let memberInfo of Object.values(teamMembers)) {
            if (memberInfo.members.includes(playerData.playerId)) {
                showTeam = true;
                break;
            }
        }
        setShowTeams(showTeam);
    }, [teamMembers])

    return (
        <div className='player-side-menu'>
            <div className='card-title center-col'>{gameData.gameName}</div>
            <div className="g-space-1"></div>
            <div className='button-list'>
                <Link to={
                    location.pathname.includes('/preview/player/')
                    ? `/preview/player/${gameData.path}`
                    : `/play/${gameData.path}`}>
                    <button 
                        className={
                            `g-button menu-btn ${
                                (
                                    path === `/play/${gameData.path}` || 
                                    path === `/preview/player/${gameData.path}`
                                )
                                ?
                                'active' : 
                                ''
                            }`
                        } 
                        title="Home" >
                        <FontAwesomeIcon 
                            icon={faHouse} 
                            className='btn-icon' 
                            size='xl' 
                        />
                        <div className='btn-text'>
                            Home
                        </div>    
                    </button>
                </Link>
                {/* INVENTORY */}
                {
                    (gameData && gameData.access.includes('items')) && 
                    <Link to={
                        location.pathname.includes('/preview/player/')
                        ? `/preview/player/${gameData.path}/inventory`
                        : `/play/${gameData.path}/inventory`
                    }>
                        <button 
                        className={`g-button menu-btn ${
                            path.includes(`/play/${gameData.path}/inventory`) ||
                            path.includes(`/preview/player/${gameData.path}/inventory`)
                            ? 'active' 
                            : ''}`
                        } 
                        title="My Inventory" >
                        <FontAwesomeIcon icon={faToolbox} className='btn-icon' size='xl' />
                        <div className='btn-text'>Your Inventory</div>
                    </button>
                    </Link>
                }
                {/* REWARDS */}
                {
                    (playerData) && 
                    <Link to={
                        location.pathname.includes('/preview/player/')
                        ? `/preview/player/${gameData.path}/rewards`
                        : `/play/${gameData.path}/rewards`
                    }>
                    <div className='notification-with-badge'>
                        <button 
                            className={
                                `${
                                    playerData.newStuff && playerData.newStuff.length > 0 
                                    ? "g-button menu-btn pending" 
                                    : "g-button menu-btn" 
                                } ${
                                    path.includes(`/play/${gameData.path}/rewards`) ||
                                    path.includes(`/preview/player/${gameData.path}/rewards`)
                                    ? 'active'
                                    : ''
                                }`
                            } 
                            title="My Rewards" >
                            <FontAwesomeIcon 
                                icon={faGem} 
                                className='btn-icon' 
                                size='xl' />
                            <div 
                                className='btn-text'>
                                Your Rewards
                            </div>
                        </button>
                        {
                            (rewardCount > 0) &&
                            <div className='badge'>
                                {rewardCount.toLocaleString()}
                            </div>
                        }
                    </div>
                    </Link>
                }
                {/* TEAMS */}
                {
                    showTeams &&
                    <Link to={
                        location.pathname.includes('/preview/player/')
                        ? `/preview/player/${gameData.path}/teams`
                        : `/play/${gameData.path}/teams`
                    }>
                        <button 
                            className={`g-button menu-btn ${
                                path.includes(`/play/${gameData.path}/teams`) ||
                                path.includes(`/preview/player/${gameData.path}/teams`) 
                                ? 'active' 
                                : ''
                            }`} 
                            title="Teams" 
                        >
                            <FontAwesomeIcon 
                                icon={faUsers} 
                                className='btn-icon' 
                                size='xl' 
                            />
                            <div className='btn-text'>
                                Your Teams
                            </div>
                        </button>
                    </Link>
                }
                {/* STORE */}
                {
                    (gameData && gameData.access.includes('store')) &&
                    <Link to={
                        location.pathname.includes('/preview/player/')
                        ? `/preview/player/${gameData.path}/marketplace`
                        : `/play/${gameData.path}/marketplace`
                    }>
                        <button 
                            className={`g-button menu-btn ${
                                path.includes(`/play/${gameData.path}/marketplace`) ||
                                path.includes(`/preview/player/${gameData.path}/marketplace`)
                                ? 'active' 
                                : ''
                            }`} 
                            title="Marketplace" 
                        >
                            <FontAwesomeIcon 
                                icon={faShoppingCart} 
                                className='btn-icon' 
                                size='xl' 
                            />
                            <div className='btn-text'>
                                Marketplace
                            </div>
                        </button>
                    </Link>
                }
                {/* SECRET CODES */}
                {
                    (gameData && gameData.access.includes('secretCodes')) &&
                    <Link to={
                        location.pathname.includes('/preview/player/')
                        ? `/preview/player/${gameData.path}/secretcode`
                        : `/play/${gameData.path}/secretcode`
                    }>
                        <button 
                            className={`g-button menu-btn ${
                                path.includes(`/play/${gameData.path}/secretcode`) ||
                                path.includes(`/preview/player/${gameData.path}/secretcode`)
                                ? 'active' 
                                : ''
                            }`} 
                            title="Submit a Secret Code" 
                        >
                            <FontAwesomeIcon 
                                icon={faUserSecret} 
                                className='btn-icon' 
                                size='xl' 
                            />
                            <div className='btn-text'>
                                Submit a Secret Code
                            </div>
                        </button>
                    </Link>
                }
                {/* CHALLENGES */}
                {
                    (gameData && gameData.access.includes('challenges')) &&
                    <Link to={
                        location.pathname.includes('/preview/player/')
                        ? `/preview/player/${gameData.path}/challenges`
                        : `/play/${gameData.path}/challenges`
                    }>
                        <button 
                            className={`g-button menu-btn ${
                                path.includes(`/play/${gameData.path}/challenges`) ||
                                path.includes(`/preview/player/${gameData.path}/challenges`)
                                ? 'active' 
                                : ''
                            }`} 
                            title="Challenges" 
                        >
                            <FontAwesomeIcon 
                            icon={faFlag} 
                            className='btn-icon' 
                            size='xl' 
                        />
                            <div className='btn-text'>
                                Challenges
                            </div>
                        </button>
                    </Link>
                }
                {/* QUESTS */}
                {
                    (gameData && gameData.access.includes('quests')) &&
                    <Link to={
                        location.pathname.includes('/preview/player/')
                        ? `/preview/player/${gameData.path}/quests`
                        : `/play/${gameData.path}/quests`
                    }>
                        <button 
                            className={`g-button menu-btn ${
                                path.includes(`/play/${gameData.path}/quests`) ||
                                path.includes(`/preview/player/${gameData.path}/quests`)
                                ? 'active' 
                                : ''
                            }`} 
                            title="Go on a Quest" >
                            <FontAwesomeIcon 
                                icon={faMap} 
                                className='btn-icon'  
                                size='xl' 
                            />
                            <div className='btn-text'>
                                Go on a Quest
                            </div>
                        </button>
                    </Link>
                }
                {/* TEAMS */}
                {/* {
                    (gameData && gameData.access.includes('teams')) &&
                    <button 
                        className={`g-button menu-btn ${path.includes(`/play/${gameData.path}/teams`) ? 'active' : ''}`} 
                        title="View My Teams" 
                        onClick={() => navigate('teams')}
                    >
                        <FontAwesomeIcon 
                            icon={faUsers} 
                            className='btn-icon' 
                            size='xl' 
                        />
                        <div className='btn-text'>
                            View My Teams
                        </div>
                    </button>
                } */}
                {/* LEADERBOARDS */}
                {
                    (
                        gameData && 
                        gameData.access.includes('leaderboards') 
                        &&
                        gameElements &&
                        Object.values(gameElements)
                        .filter(e => e.type === 'leaderboard').length > 0
                    ) &&
                    <Link to={
                        location.pathname.includes('/preview/player/')
                        ? `/preview/player/${gameData.path}/leaderboards`
                        : `/play/${gameData.path}/leaderboards`
                    }>
                        <button 
                            className={`g-button menu-btn ${
                                path.includes(`/play/${gameData.path}/leaderboards`) ||
                                path.includes(`/preview/player/${gameData.path}/leaderboards`)
                                ? 'active' 
                                : ''
                            }`} 
                            title="Leaderboards" 
                        >
                            <FontAwesomeIcon 
                                icon={faRectangleList} 
                                className='btn-icon' 
                                size='xl' />
                            <div className='btn-text'>
                                Leaderboards
                            </div>
                        </button>
                    </Link>
                }
                <Link to={
                    location.pathname.includes('/preview/player/')
                    ? `/preview/player/${gameData.path}/gameactivity`
                    : `/play/${gameData.path}/gameactivity`
                }>
                    <button 
                        className={`g-button menu-btn ${
                            path.includes(`/play/${gameData.path}/gameactivity`) ||
                            path.includes(`/play/${gameData.path}/transaction`) ||
                            path.includes(`/preview/player/${gameData.path}/gameactivity`) ||
                            path.includes(`/preview/player/${gameData.path}/transaction`)
                            ? 'active' : ''
                        }`} 
                        title="View Game Activity" 
                    >
                        <FontAwesomeIcon 
                            icon={faGlobeAmericas} 
                            className='btn-icon' 
                            size='xl' 
                        />
                        <div className='btn-text'>
                            View Your Activity
                        </div>
                    </button>
                </Link>
            </div>
                
        </div>
  )
}

export default PlayerSideMenu;